import { ofType } from 'redux-observable';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ROOT_URL, saveError } from 'Api';
import service from 'Api/service';
import converter from 'json-style-converter/es5';

import { FETCH_INVENTORY_AVAILABILITY_REQUEST } from 'Constants/redux';
import { SOFT_HOLDS_KEY } from 'HelperFunctions/availability';
import {
  fetchInventoryAvailabilitySuccess,
  fetchInventoryAvailabilityFailure,
} from 'Actions/AvailabilityActions';

const fetchInventoryAvailabilityEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_INVENTORY_AVAILABILITY_REQUEST),
    mergeMap((action) => {
      const { startDate, endDate } = action.requestPayload;
      const { availabilityTypeKey } = action;
      const payload = converter.camelToSnakeCase(action.requestPayload);

      if (!startDate || !endDate) {
        return of(
          fetchInventoryAvailabilityFailure(
            'No date interval provided',
            availabilityTypeKey
          )
        );
      }

      return from(
        service.post(`${ROOT_URL}/inventories/available_in_period`, {
          ...payload,
          multilocation: true,
          // Soft-hold numbers never feed the ledger views, so skip that work.
          ledger: availabilityTypeKey !== SOFT_HOLDS_KEY,
        })
      ).pipe(
        map((res) =>
          fetchInventoryAvailabilitySuccess(
            res.data.availability,
            availabilityTypeKey
          )
        ),
        catchError((error) => {
          saveError(error);
          return of(
            fetchInventoryAvailabilityFailure(error, availabilityTypeKey)
          );
        })
      );
    })
  );

export default fetchInventoryAvailabilityEpic;
